import axios from '../Backend';

export const getAllCampaigns = async () => {
    try {
        const response = await axios.get(`/api/v2/campaigns`);
        const resData = response.data;
        return resData;
    } catch (e) {
        console.log('axios/campaignReq/getAllCampaigns :: Error')
        console.log(JSON.stringify(e?.response?.data))
    }
}

export const editCampaignActiveOrNo = async (campaignId, campaignObject) => {
    try {
        const response = await axios.patch(`/api/v2/campaigns/${campaignId}`, campaignObject);
        const resData = response.data;
        return resData;
    } catch (e) {
        console.log('axios/campaignReq/editCampaignActiveOrNo :: Error')
        console.log(JSON.stringify(e?.response?.data))
    }
}
